import React, { useEffect, useState } from 'react';
import { Calendar } from 'lucide-react';
import { REGISTRATION_FORM_URL } from '../constants/links';

function useIsPastHero() {
  const [isPastHero, setIsPastHero] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('inicio');
    if (!hero) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsPastHero(!entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return isPastHero;
}

const MobileStickyCta: React.FC = () => {
  const isPastHero = useIsPastHero();

  if (!isPastHero) {
    return null;
  }

  return (
    <div className="mobile-sticky-cta" role="region" aria-label="Acción principal">
      <a
        href={REGISTRATION_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mobile-sticky-cta__button"
      >
        <Calendar size={18} aria-hidden="true" />
        <span>Inscríbete ahora</span>
      </a>
    </div>
  );
};

export default MobileStickyCta;
